<template>
  <ul class="cn-header-menu">
    <slot :active-item="activeItem" :set-active-item="setActiveItem" />
  </ul>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useElementHover } from '@vueuse/core';

interface Props {
  headerRef?: any;
}

const props = defineProps<Props>();
const route = useRoute();
const menu = computed(() => props.headerRef);
const isHovered = useElementHover(menu);
const activeItem = ref(null);
const setActiveItem = (index) => {
  activeItem.value = index;
};

watch(isHovered, (value) => {
  if (value === false) activeItem.value = null;
});

watch(
  () => route.fullPath,
  () => {
    activeItem.value = null;
  },
);
</script>
<style>
.cn-header-menu {
  display: flex;
}
</style>
